import { useEffect, useState } from "react";
import { gsap } from "gsap";

const Loader = () => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Simulate loading progress
    const interval = setInterval(() => {
      setProgress(prev => {
        const newProgress = prev + Math.random() * 15;
        return newProgress > 100 ? 100 : newProgress;
      });
    }, 400);

    // Animate the snowflake loader
    gsap.to(".loader-snowflake", {
      rotation: 360,
      duration: 4,
      repeat: -1,
      ease: "linear"
    });

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loader">
      <div className="loader-content">
        <div className="loader-snowflake">
          <svg width="50" height="50" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M60 0L63.3 56.7L120 60L63.3 63.3L60 120L56.7 63.3L0 60L56.7 56.7L60 0Z" fill="white"/>
          </svg>
        </div>
        <div className="progress-bar">
          <div 
            className="progress-fill" 
            style={{ width: `${progress}%` }}
          ></div>
        </div>
        <div className="loader-text">WINTERSIX</div>
      </div>
    </div>
  );
};

export default Loader;
